import store from '@/store'
/**
 *
 * @export 日期格式化
 * @param {any} fmt 格式
 * @param {any} date 预格式的日期，是个日期对象
 * @returns
 */
export function formatDate (fmt, date) {
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length)) }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) { fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
  }
  return fmt
}

/**
 * @export 根据编码返回地区对应中文
 * @param {any} provinceCode 省编码
 * @param {any} cityCode 市编码
 * @param {any} countyCode 区编码
 * @returns 省市区中文
 */
export function getAreaStr (provinceCode, cityCode, countyCode) {
  let address = ''
  const areaList = store.state.areaList || []
  if (provinceCode) {
    const proData = areaList.filter(item => item.id === provinceCode)
    if (proData.length > 0) {
      address = proData[0].name
      if (cityCode && proData[0].children.length > 0) {
        const cityData = proData[0].children.filter(atem => atem.id === cityCode)
        if (cityData.length > 0) {
          address += cityData[0].name
          if (countyCode && cityData[0].children.length > 0) {
            const countyData = cityData[0].children.filter(atem => atem.id === countyCode)
            if (countyData.length > 0) {
              address += countyData[0].name
            }
          }
        }
      }
    }
  }
  return address
}

export function getAreaStr1 (provinceCode, cityCode, countyCode) {
  let address = ''
  const areaList = store.state.areaList || []
  if (provinceCode) {
    const proData = areaList.filter(item => item.id === provinceCode)
    if (proData.length > 0) {
      address = proData[0].name
      if (cityCode && proData[0].children.length > 0) {
        const cityData = proData[0].children.filter(atem => atem.id === cityCode)
        if (cityData.length > 0) {
          address += ' ' + cityData[0].name
          if (countyCode && cityData[0].children.length > 0) {
            const countyData = cityData[0].children.filter(atem => atem.id === countyCode)
            if (countyData.length > 0) {
              address += ' ' + countyData[0].name
            }
          }
        }
      }
    }
  }
  return address
}

/**
 * @export 富文本表情图处理
 * @param {any} content 富文本内容
 * @returns 修改后的富文本
 */
export function richTextImg (content) {
  if (content) {
    const regex = new RegExp('<img', 'g')
    content = content.replace(regex, `<img style="max-width: 100%;"`)
    // 表情包地址变化
    const emojiRegex = new RegExp('src="../../../lib/tinymce/plugins/emoticons/img/', 'g')
    const emojiUrl = '/img/emoji/'
    content = content.replace(emojiRegex, 'src="' + emojiUrl)
  }
  return content
}

/**
 * @export 文本换行
 * @param {any} content 多行文本内容
 * @returns 修改后的富文本
 *
 */
export function richTextWrap (content) {
  if (content) {
    content = content.replace(/↵/g, '<br/>')
  }
  return content
}
